import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'
import { toCalendarTasks } from './serializers'
import { timezoneDate } from 'utils/helpers'
import { getDateFormat } from 'utils/authService'
import moment from 'moment-timezone'

const initialState = {
  tasks: [],
  events: [],
  bids: [],
  followUps: [],
  leads: []
}

const calendarReducer = createReducer(initialState, {
  [ACT.CALENDAR_TASKS_FETCH_SUCCESS](state, action) {
    const { tasks } = action.payload
    return {
      ...state,
      tasks
    }
  },

  [ACT.CALENDAR_EVENTS_FETCH_SUCCESS](state, action) {
    const { events } = action.payload
    return {
      ...state,
      events
    }
  },

  [ACT.CALENDAR_BIDS_FETCH_SUCCESS](state, action) {
    const { deals } = action.payload
    return {
      ...state,
      bids: deals
    }
  },

  [ACT.CALENDAR_LEADS_FETCH_SUCCESS](state, action) {
    const { leads } = action.payload
    return {
      ...state,
      leads: leads
    }
  },

  [ACT.CALENDAR_FOLLOWUPS_FETCH_SUCCESS](state, action) {
    const { deals } = action.payload
    return {
      ...state,
      followUps: deals
    }
  },

  [ACT.CALENDAR_DEAL_DATE_UPDATE](state, action) {
    const { date, id, followUpView } = action.payload
    const deals = followUpView ? state.followUps : state.bids
    const index = deals.findIndex(d => d.id === id)

    const newState = update(state, {
      [followUpView ? 'followUps' : 'bids']: {
        [index]: {
          start: {
            $set: moment(timezoneDate(date, 'HH:mm:ss'), `${getDateFormat()} HH:mm:ss`).toDate()
          },
          end: {
            $set: moment(timezoneDate(date, 'HH:mm:ss'), `${getDateFormat()} HH:mm:ss`).toDate()
          }
        }
      }
    })

    return newState
  },

  [ACT.UPDATE_DEAL_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => +t.task.id === task.id)

    return update(state, {
      tasks: {
        [index]: { $set: toCalendarTasks([task])[0] }
      }
    })
  },

  [ACT.DEAL_TASK_MARK_COMPLETED_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => t.id === task.id)
    return update(state, {
      tasks: {
        [index]: { $set: toCalendarTasks([task])[0] }
      }
    })
  },

  [ACT.DELETE_DEAL_TASK_SUCCESS](state, action) {
    const { task } = action.payload
    const index = state.tasks.findIndex(t => +t.id === task.id)

    return update(state, {
      tasks: {
        $splice: [[index, 1]]
      }
    })
  },

  [ACT.CALENDAR_EVENT_UPDATE_SUCCESS](state, action) {
    const { event } = action.payload
    const index = state.events.findIndex(t => +t.id === event.id)

    return update(state, {
      events: {
        [index]: { $set: event }
      }
    })
  },

  [ACT.CALENDAR_EVENT_SAVE_SUCCESS](state, action) {
    const { event } = action.payload

    return update(state, {
      events: { $push: [event] }
    })
  },

  [ACT.CALENDAR_EVENT_DELETE_SUCCESS](state, action) {
    const { id } = action.payload
    const index = state.events.findIndex(t => +t.id === id)

    return update(state, {
      events: { $splice: [[index, 1]] }
    })
  }
})

export default calendarReducer
